import { PricesResendManager } from "..";
import { YieldType } from "../../../service/globalTypes";
import { resetStylesForUpdatedSecurityProducer, setLastYieldSentAndTimestamp } from "../../../service/producerServices";
import { HandleSuccessfulResendArgs } from "./types";

export const handleSuccessfulResend = ({ row, resendTryResults, bid, ask }: HandleSuccessfulResendArgs) => {
  resetStylesForUpdatedSecurityProducer({ sentRow: row, validateYieldValues: false });

  resendTryResults.forEach(({ yieldType }) => {
    const valueSent = yieldType === YieldType.BID ? bid : ask;

    setLastYieldSentAndTimestamp({ yieldType, value: valueSent, row: row - 1 });
  });

  PricesResendManager.getInstance().popErrorsList();
};
